export default __webpack_public_path__ + "static/media/like-icon.d23f04ff.svg";